import {Field, formValueSelector, change} from 'redux-form'
import styles from './SearchForm.css'
import {connect} from 'react-redux'
import {
  taxAssignToItemItemsRequest
} from 'actions/library/tax'
import Select from 'react-select'
import 'react-select/dist/react-select.css'

class RenderSelectField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectInstance: 1 // TOREMOVE TODELETE
    }
  }

  onChangeSelect = (newval) => {
    // const {input: {value, onChange}, meta: {dispatch}, options, categories} = this.props
    const {input: {onChange}} = this.props
    onChange(newval.value)
  }

  render () {
    let {input: {value}, placeholder, options} = this.props
    if (value === '') {
      value = 0 // for initial when value not specified, set all All Categories
    }
    const selectProps = {
      // TODELETE addLabelText: '{label} (create new)',
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      clearable: false,
      backspaceRemoves: false,
      // TODELETE promptTextCreator: (label) => (`${label} (create new)`),
      onClose: () => { this.setState({selectInstance: 1 - this.state.selectInstance}) }
    }
    return <span><Select
      {...selectProps}
    /></span>
  }
}

class Search extends React.Component {
  _formatCategories = (categories) => {
    let formatCategory = []
    formatCategory.push({value: 0, label: 'All Categories'}) // create All Categories
    categories.map(function (category) {
      if (category.id > 0) {
        formatCategory.push({value: category.id, label: category.name})
      }
    })
    return formatCategory
  }

  componentWillMount () { // initialize each time it opens
    const {dispatch} = this.props
    // dispatch(change('taxAssignToItem', 'category_id', 0)) // No need will be set by action
    dispatch(change('taxAssignToItem', 'keyword', ''))
  }

  render () {
    let { categories } = this.props
    return (<div className={`row ${styles.wrapper}`}>
      <div className={`col-md-4 ${styles['search-select']}`}>
        <div className={`form-group`}>
          <Field
            component={RenderSelectField}
            className='selectCategories'
            name='category_id'
            options={this._formatCategories(categories)}
            categories={categories}
            onChange={this._onChangeFilterCategory}
            placeholder='Select an option'
          />
        </div>
      </div>
      <div className='col-md-8'>
        <div className='right-inner-addon'>
          <i className='fa fa-search' />
          <Field
            component='input'
            name='keyword'
            className='form-control'
            placeholder='Search items'
            onChange={this._onChangeFilterKeyword}
            value=''
          />
        </div>
      </div>
    </div>)
  }

  _onChangeFilterKeyword = (event, keyword) => {
    const {taxAssignToItem, dispatch} = this.props
    dispatch(change('taxAssignToItem', 'keyword', keyword))
    dispatch(taxAssignToItemItemsRequest({page: 1, keyword, with_batch: true, categoryId: taxAssignToItem.category_id, itemIds: taxAssignToItem.itemIds}, []))
  }

  _onChangeFilterCategory = (event, categoryId) => {
    const {taxAssignToItem: {itemIds}, dispatch} = this.props
    dispatch(change('taxAssignToItem', 'category_id', categoryId))
    dispatch(change('taxAssignToItem', 'keyword', '')) // reset the keyword, taxAssignToItem.keyword to ''
    dispatch(taxAssignToItemItemsRequest({page: 1, keyword: '', with_batch: true, categoryId, itemIds}, []))
    // mpItemList.libraryItemChangeFilter({ category: categoryId }) // for reference for now.
  }
}

const selector = formValueSelector('taxAssignToItem')

function mapStateToProps (state) {
  const {taxAssignToItems: {items, currentPage, totalPage}, taxDetail, categories, checkSelectAllTaxItemsFlag} = state.library.tax
  return {
    taxDetail,
    taxAssignToItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword'),
      category_id: selector(state, 'category_id')
    },
    items,
    currentPage,
    totalPage,
    categories,
    checkSelectAllTaxItemsFlag
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)




// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxAssignToItemModal/Search/Search.js